/**
 * TO-DO: Animations for slider
 */

import Modal from '../components/modal';
import Player from "@vimeo/player";

export default {
	name: "Stage",
	components: {
		Modal
	},
	data() {
		return {
			currSlide: 0,
			movie: null,
			show_movie: false,
		}
	},
	mounted() {
		this.movie = new Player(this.$refs['movie'].querySelector('iframe'));
	},
	methods: {
		showMovie() {
			this.show_movie = true;
		},
		hideMovie() {
			this.show_movie = false;
			this.movie.unload();
		},
	},
}
